import UIComponent from '../../common/UIComponent';
import { secondFormat } from '../../common/Utils';
import './index.css';

export default class ProgressPointTime extends UIComponent {
  constructor(rootNode, interfaces, config) {
    super();
    this.interfaces = interfaces;
    this.rootNode = rootNode;
    this.mainNode = null;
    this.config = config;
    this.config = {
      enable: true
    };
    //初始化元素
    this.init();
  }

  init() {
    this.mainNode = document.createElement('div');
    this.mainNode.setAttribute('class', 'vhallPlayer-progess-point-time hide');
    this.rootNode.appendChild(this.mainNode);
  }

  /**
   * 根据进度条位置状态，获取雪碧图所需参数和样式
   * @param {*} offsetX
   * @param {*} progessWidth
   * @param {*} now
   * @param {*} containerWidth
   * @param {*} containerHeight
   * @returns
   */
  getPosition(offsetX, progessWidth) {
    let per = 0;
    if (offsetX < this.mainNode.offsetWidth / 2) {
      per = 0;
    } else if (offsetX > progessWidth - this.mainNode.offsetWidth) {
      per = ((progessWidth - this.mainNode.offsetWidth) / progessWidth) * 100;
    } else {
      per = ((offsetX - this.mainNode.offsetWidth / 2) / progessWidth) * 100;
    }
    return {
      style: {
        // width: `${swidth}px`,
        // height: `${sHeight}px`,
        left: `${per}%`
      }
    };
  }

  // 更新内容
  update(offsetX, progessWidth, now) {
    if (this.config.enable) {
      //更新时间点显示文本
      const currentTimeStr = secondFormat(now);
      this.mainNode.innerText = currentTimeStr;
      //更新CSS样式
      const pos = this.getPosition(offsetX, progessWidth);
      Object.keys(pos.style).map(key => {
        this.mainNode.style[key] = pos.style[key];
      });
    }
  }

  //对外方法，显示元素
  show() {
    if (this.config.enable) {
      this.mainNode.classList.remove('hide');
    }
  }
  //对外方法，隐藏元素
  hide() {
    if (this.config.enable) {
      this.mainNode.classList.add('hide');
    }
  }
}
